<template>
  <div class="not found">
    <p>Redirecting...</p>
  </div>
</template>
<script>
export default {
  mounted() {
    window.location.href = "/login";
  }
};
</script>
<style scoped>
* {
  margin: unset !important;
}
</style>